export default "__VITE_ASSET__77BBoAMw__"